<div class="component-name d-flex align-items-center">
    <div class="icon">
        <img appImageSelector alt="mt-image" [imageKey]="icon" [imageType]="'section'"  *ngIf="isSectionHeader">
    </div>
    <div class="description">
        <div class="title" *ngIf="title === 'dsh' && (dashboardFacade.isTitleDashboard$ | async ) === true" [ngStyle]="{'color': (isSectionHeader ? '#FF9900' : '#F1F1F1'), 
                                    'fontSize': (isSectionHeader ? '16' : '14') + 'px'}">
                                    {{(title | lang) || ''}} {{(dashboardFacade.titleDashboard$ | async )}}</div>
        <div class="title" *ngIf="title === 'dsh' && (dashboardFacade.isTitleDashboard$ | async ) === false" [ngStyle]="{'color': (isSectionHeader ? '#FF9900' : '#F1F1F1'), 
                                    'fontSize': (isSectionHeader ? '16' : '14') + 'px'}">
                                    {{(title | lang) || ''}} {{secondTitle}}</div>
        <div class="title" *ngIf="title !== 'dsh'" [ngStyle]="{'color': (isSectionHeader ? '#FF9900' : '#F1F1F1'), 
                                    'fontSize': (isSectionHeader ? '16' : '14') + 'px'}">
                                    {{(title | lang) || ''}}</div>
                                    
                                    

        <div class="detail" [ngStyle]="{'color': (isSectionHeader ? '#AFAFAF' : '#FFFFFF'),
                                    'fontWeight': (isSectionHeader ? 600 :  400)}">
                                        {{displayDetail}} {{displayDetail && hours}}</div>
    </div>
</div>